import { userApi } from "@/core/data/api";

export default async (userId) => {
  return await userApi.logout(userId);
};
